var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5225 17.5225 22 12 22C6.4775 22 2 17.5225 2 12C2 6.4775 6.4775 2 12 2C17.5225 2 22 6.4775 22 12Z",
    fill: "url(#paint0_radial_2158_21894)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22C14.8976 22 17.4991 20.76 19.3256 18.791C18.0886 15.9715 15.2761 14 12.0001 14C8.72406 14 5.91156 15.9715 4.67456 18.791C6.50106 20.76 9.10256 22 12.0001 22Z",
    fill: "url(#paint1_radial_2158_21894)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.75C14.6234 14.75 16.75 12.6234 16.75 10C16.75 7.37665 14.6234 5.25 12 5.25C9.37665 5.25 7.25 7.37665 7.25 10C7.25 12.6234 9.37665 14.75 12 14.75Z",
    fill: "url(#paint2_radial_2158_21894)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C14.2091 13.5 16 11.7091 16 9.5C16 7.29086 14.2091 5.5 12 5.5C9.79086 5.5 8 7.29086 8 9.5C8 11.7091 9.79086 13.5 12 13.5Z",
    fill: "url(#paint3_linear_2158_21894)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 22C14.5074 22 16.7934 21.0705 18.5489 19.5455C17.5534 16.892 15.0009 15 11.9999 15C8.99893 15 6.44643 16.892 5.45093 19.5455C7.20643 21.0705 9.49243 22 11.9999 22Z",
    fill: "url(#paint4_linear_2158_21894)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2158_21894",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.5885 4.1965) scale(20.156)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0370C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#036FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#036ABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0362B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2158_21894",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0001 22.054) scale(8.07)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2158_21894",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 10) scale(4.75)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2158_21894",
    x1: 9.2865,
    y1: 6.7865,
    x2: 14.8675,
    y2: 12.3675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2158_21894",
    x1: 8.50343,
    y1: 15.605,
    x2: 15.4439,
    y2: 22.5455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA2E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.99fdec46b2b8f83d26b6b1a2449e9340.svg";
export { ForwardRef as ReactComponent };